import { render, staticRenderFns } from "./SupperFatFemale.vue?vue&type=template&id=2205943b&scoped=true&"
import script from "./SupperFatFemale.vue?vue&type=script&lang=js&"
export * from "./SupperFatFemale.vue?vue&type=script&lang=js&"
import style0 from "./SupperFatFemale.vue?vue&type=style&index=0&id=2205943b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205943b",
  null
  
)

export default component.exports